<div class="overflow-hidden">
  <div class="dropdown-container">
    <div class="dropdown-junctures-container">

      <app-banner-juncture [imagePath]="imagePath"></app-banner-juncture>

      <app-age-juncture [lang]="DataService.selectedLanguage" [HIPContractDto]="HIPContractDto" (newInsurantDataEvent)="userDataServe($event)" (newInsurantDataLocation)="userDataServe($event)" [ngClass]="{'minimize': this.FlagService.flagServiceObject[1]['offerJunctureFlag']}"></app-age-juncture>
      @if (this.FlagService.flagServiceObject[1]['offerJunctureFlag']) {
        <app-offer-juncture [lang]="DataService.selectedLanguage" (newInsurantDataEvent)="userDataServe($event)" (newInsurantDataLocation)="userDataServe($event)" [ngClass]="{'minimize': this.FlagService.flagServiceObject[2]['familyJunctureFlag']}"></app-offer-juncture>
      }
      @if (this.FlagService.flagServiceObject[2]['familyJunctureFlag']) {
        <app-family-juncture [lang]="DataService.selectedLanguage" [HIPContractDto]="HIPContractDto" (newInsurantDataEvent)="userDataServe($event)" (newInsurantDataLocation)="userDataServe($event)" [ngClass]="{'minimize': this.FlagService.flagServiceObject[3]['userdataJunctureFlag']}"></app-family-juncture>
      }
      @if (this.FlagService.flagServiceObject[3]['userdataJunctureFlag']) {
        <app-userdata-juncture (newInsurantDataEvent)="userDataServe($event)" (newInsurantDataLocation)="userDataServe($event)"></app-userdata-juncture>
      }
      @if (this.FlagService.flagServiceObject[4]['socsecurityJunctureFlag'] && !DataService.isKompakt()) {
        <app-socsecurity-juncture (newInsurantDataEvent)="userDataServe($event)" (newInsurantDataLocation)="userDataServe($event)"></app-socsecurity-juncture>
      }
      @if (this.FlagService.flagServiceObject[5]['contactinfoJunctureFlag']) {
        <app-contactinfo-juncture (newInsurantDataEvent)="userDataServe($event)" (newInsurantDataLocation)="userDataServe($event)"></app-contactinfo-juncture>
      }
      @if (this.FlagService.flagServiceObject[6]['payfrequencyJunctureFlag']) {
        <app-payfrequency-juncture (newInsurantDataEvent)="userDataServe($event)" (newInsurantDataLocation)="userDataServe($event)"></app-payfrequency-juncture>
      }
      @if (this.FlagService.flagServiceObject[7]['conditionsJunctureFlag']) {
        <app-conditions-juncture [lang]="DataService.selectedLanguage" [HIPContractDto]="HIPContractDto"></app-conditions-juncture>
      }
      @if (this.FlagService.flagServiceObject[8]['captchaJunctureFlag']) {
        <app-captcha-juncture></app-captcha-juncture>
      }

      @if (this.FlagService.flagServiceObject[9]['finalpaymentJunctureFlag']) {
        <app-finalpayment-juncture></app-finalpayment-juncture>
      }

      <app-footer></app-footer>

    </div>
  </div>
</div>
